import axiosInstanceNew from "../lib/axiosinstanceNew";
const ProfileSubAdmins = class {

    constructor(){
        this.baseUrl="user/profile";
    }


  // subAdmin
  async Getprofile () {
    return (await axiosInstanceNew.get(`${this.baseUrl}`));
  }
  async Getlist () {
    return (await axiosInstanceNew.get(`user/list`));
  }
  async update (id,data) {
    return (await axiosInstanceNew.put(`user/update/${id}`,data));
  }
}

export default new ProfileSubAdmins();